import "@solana/wallet-adapter-react-ui/styles.css";
import "@/translations";

import Router from "@/router";

export default function App() {
  return <Router />;
}
